<script setup>
const $props = defineProps({
    // Each card carries a title and its points, every point a bold label followed by plain text.
    cards: {
        type: Array,
        required: true
    },
    lead: {
        type: String,
        required: true
    }
});
</script>

<template>
    <section aria-labelledby="tldr" class="legal-summary q-mb-xl">
        <h2 id="tldr" class="text-h4 text-weight-bold">TL;DR</h2>
        <p>{{ $props.lead }}</p>
        <div class="row q-col-gutter-md">
            <div v-for="card of $props.cards" :key="card.title" class="col-12 col-md-6">
                <article class="readout-frame full-height q-pa-lg">
                    <h3 class="text-h6 text-weight-bold q-mt-none q-mb-sm">{{ card.title }}</h3>
                    <ul class="q-my-none">
                        <li v-for="point of card.points" :key="point.label">
                            <strong>{{ point.label }}</strong> {{ point.text }}
                        </li>
                    </ul>
                </article>
            </div>
        </div>
    </section>
</template>
